import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Require reference number for concierge return moves.
 */
export const schema = z.boolean();

export type ReferenceNumRequiredForReturn = z.infer<typeof schema>;

export const definition = define({
  key: 'reference_num_required_for_return',
  schema,
  label: 'Ref Required for Concierge Return',
  description: 'Require the reference number to be entered for concierge return moves.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.REFERENCE_NUMBER.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: false,
});
